function serializeNode(node: ChildNode): string {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent ?? '';
  if (node.nodeType !== Node.ELEMENT_NODE) return '';

  const el = node as HTMLElement;
  const inner = Array.from(el.childNodes).map(serializeNode).join('');

  switch (el.tagName) {
    case 'B':
    case 'STRONG':
      return inner ? `**${inner}**` : '';
    case 'I':
    case 'EM':
      return inner ? `_${inner}_` : '';
    case 'U':
      return inner ? `++${inner}++` : '';
    case 'BR':
      return '\n';
    case 'DIV':
    case 'P':
      return `\n${inner}`;
    default:
      return inner;
  }
}

export function htmlToFormattedText(root: HTMLElement): string {
  const raw = Array.from(root.childNodes).map(serializeNode).join('');
  return raw.replace(/^\n+/, '').replace(/\n{3,}/g, '\n\n');
}
